import axios from "axios";

const auditLogService = {
  getAuditLogs: async ({ event, module, route, user_id, label }) => {
    const objectData = {
      brand: "Abbott",
      event: event,
      user_id: user_id,
      data: {
        route: route,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        screenResolution: `${window.screen.width}x${window.screen.height}`,
        module: module,
        label: label,
      },
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/audit-log`,
        objectData,
        {
          headers: {
            "X-Environment": process.env.REACT_APP_ENV || "development",
          },
        }
      );
      if (response.status === 200) {
        return response;
      } else {
        console.log("Failed to fetch audit logs");
      }
    } catch (error) {
      console.error("Error sending audit log:", error);
      throw error;
    }
  },
};
export default auditLogService;
